import React from 'react';
import {
  ClickAwayListener,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Drawer,
  Grow,
  Paper,
  Popper
} from '@mui/material';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { paperClasses } from '@mui/material/Paper';
import { useWindowSize } from '../../../utils/hooks';
import { MOBILE_BREAKPOINT } from '../../../utils/constants';

function DeleteDialog(props) {
  const { open, closeHandler, confirmHandler, config } = props;
  const { t } = useTranslation();

  const size = useWindowSize();

  const deleteDialogContent = (
    <>
      <DialogContent
        sx={{
          ml: 4,
          mr: 4,
          p: 1.5
        }}
      >
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            pt: 2,
            minHeight: 70,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            color: size.width > MOBILE_BREAKPOINT ? '#003B58' : '#000000',
            fontSize: size.width > MOBILE_BREAKPOINT ? '16px' : '12px'
          }}
        >
          <p>{config.text}</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          ml: 4,
          mr: 4,
          mb: 4,
          p: 0,
          justifyContent: 'space-around'
        }}
      >
        <Button
          onClick={closeHandler}
          variant="outlined"
          sx={{
            textTransform: 'none',
            mr: 1,
            minWidth: 105,
            color: '#77787B',
            fontSize: '12px',
            borderColor: '#77787B'
          }}
        >
          {t('common.general.cancel')}
        </Button>
        <Button
          onClick={confirmHandler}
          variant="filled"
          // color="error"
          sx={{
            textTransform: 'none',
            minWidth: 105,
            background: 'linear-gradient(180deg, rgba(0, 73, 118, 0) 0%, #004876 100%), #009ACE',
            color: 'white',
            fontSize: '12px',
            '&:hover': {
              background: 'linear-gradient(180deg, rgba(0, 73, 118, 0) 0%, #004876 100%), #009ACE'
            }
          }}
        >
          {t('common.general.yes')}
        </Button>
      </DialogActions>
    </>
  );

  return size.width > MOBILE_BREAKPOINT ? (
    <Dialog
      open={open}
      onClose={closeHandler}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        zIndex: 1700,
        '& .MuiDialog-paper': {
          borderRadius: '10px'
        }
      }}
    >
      {deleteDialogContent}
    </Dialog>
  ) : (
    <Popper open={open} role={undefined} placement="bottom-start" transition disablePortal>
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom'
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={closeHandler}>
              <Drawer
                anchor="bottom"
                open={open}
                onClose={closeHandler}
                sx={{
                  [`& .${paperClasses.root}`]: {
                    borderRadius: '10px 10px 0 0'
                  }
                }}
              >
                {deleteDialogContent}
              </Drawer>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}

export default DeleteDialog;
